import styles from "./index.module.scss";
import { useProgress } from "@/hooks";
import type { TProgressProps } from "@/types";
import clsx from "clsx";
import { useState } from "react";

const ProgressBar = (props: TProgressProps) => {
  const {
    onControl,
    onOutOfControl,
    ...restProps
  } = props;

  const [isControl, setIsControl] = useState(false);

  const {
    rootEleRef,
    progressEleRef,
    controlBarEleRef,
    controlButtonEleRef,
    clickControlBar,
    focusControlButton,
  } = useProgress({
    onControl: () => {
      onControl?.();
      setIsControl(true);
    },
    onOutOfControl: () => {
      onOutOfControl?.();
      setIsControl(false);
    },
    ...restProps
  });

  return (
    <div
      ref={rootEleRef}
      className={clsx(
        styles["progress_bar"],
        isControl && styles["is_control"]
      )}
    >
      <div
        className={styles["track"]}
      >
        <div
          className={styles["cache_bar"]}
        ></div>

        <div
          ref={progressEleRef}
          className={styles["progress"]}
        ></div>

        <div
          ref={controlBarEleRef}
          className={styles["control_bar"]}
          onClick={clickControlBar}
        ></div>

        <button
          ref={controlButtonEleRef}
          className={styles["control_button"]}
          onMouseDown={focusControlButton}
        ></button>
      </div>
    </div>
  )
}

export default ProgressBar;